import { render } from "./BuyWithConfidencePage.vue?vue&type=template&id=791c508f&scoped=true"
import script from "./BuyWithConfidencePage.vue?vue&type=script&lang=js"
export * from "./BuyWithConfidencePage.vue?vue&type=script&lang=js"

import "./BuyWithConfidencePage.vue?vue&type=style&index=0&id=791c508f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791c508f"]])

export default __exports__